module.exports = __webpack_public_path__ + "static/media/map-marker.d260dc4c.svg";